module.exports = __webpack_public_path__ + "static/media/male-30.2d04fb9d.png";